import { render, staticRenderFns } from "./Tarjetas.vue?vue&type=template&id=2d305720&scoped=true"
import script from "./Tarjetas.vue?vue&type=script&lang=js"
export * from "./Tarjetas.vue?vue&type=script&lang=js"
import style0 from "./Tarjetas.vue?vue&type=style&index=0&id=2d305720&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d305720",
  null
  
)

export default component.exports